module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpoti.4748d9660fe941917a353e6d22f3cd41.png";